export default __webpack_public_path__ + "img/feyzin.a83041c0.jpg";